import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../hooks'
import { MoneyInput } from '../../Currency'
import { FormikField, getFormikFormFieldErrorProps } from '../../Formik'
import { LISTING_FORM_FIELD_NAME_RENT_PRICE } from '../RentalPortalListing.constants'

function RentalPortalListingRentPriceField({ isLoading }) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      Component={MoneyInput}
      controlProps={{ borderless: !isMobileScreenSize }}
      fieldComponentProps={{
        isLoading,
        label: `${t('RentalPortal.ListingFormRentPriceLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      name={LISTING_FORM_FIELD_NAME_RENT_PRICE}
      placeholder={t('RentalPortal.ListingFormRentPricePlaceholderKey')}
    />
  )
}

export default RentalPortalListingRentPriceField
